import { TagTheme } from '@/components/Tag/theme';
import { tw } from '@/utils/tw';
import { LinkTheme } from '@/components/Link/theme';

const Tag = tw.theme({
  extend: TagTheme,
  defaultVariants: {
    size: 'small',
  },
});

const DisclaimerLink = tw.theme({
  extend: LinkTheme,
  slots: {
    base: `font-bold`,
  },
});

const ArticleFooter = tw.theme({
  slots: {
    base: `flex w-full flex-col gap-4`,
    tags: `mx-auto flex w-full flex-wrap justify-start gap-1.5 md:max-w-article`,
    disclaimer: 'prose mx-auto flex w-full max-w-article items-center bg-gray-100 p-3',
    disclaimerText: ``,
  },
  variants: {
    center: {
      true: {
        tags: `justify-center`,
      },
    },
  },
});

export default Object.assign(ArticleFooter, { Tag, DisclaimerLink });
